/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');

var SubmitCompliancePaymentCosts = require('../services/SubmitCompliancePaymentCosts');

var tmplSecComplianceCostEditModalView = require('../templates/SecComplianceCostEditModalView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecComplianceCostEditModalView,

  className: 'compliance-cost-edit-modal-view',

  ui: {
    modalBody: '.modal-body',
    costForm: '.cost-form',
    submit: '.submit'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    Syphon.deserialize(this, this.model.toJSON());
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.ui.costForm
      .parsley()
      .whenValidate()
      .done(function() {
        var l = Ladda.create(self.ui.submit[0]);
        l.start();

        SubmitCompliancePaymentCosts(self.getFormData())
          .done(function(updatedCosts) {
            self.triggerMethod('modal:close', updatedCosts);
          })
          .fail(function() {
            l.stop();
          });
      });
  },

  getFormData: function() {
    var data = Syphon.serialize(this);
    data.complianceId = this.model.get('complianceId');
    return data;
  }
});
